import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmProjectCustomerNotificationsTemplateRoute: InvariantJiraRoute = {
	name: 'csm-project-customer-notifications-template',
	path: '/jira/customer-service-management/experiences/projects/:projectKey/settings/:helpCenterId/customer-notifications/template',
	exact: true,
};
